<template>
  <div>
    <v-toolbar flat color="white">
      <v-spacer></v-spacer>
      <v-text-field label="Search" v-model="search"></v-text-field>
      <v-btn color="primary" class="white--text" round @click="addItem()"
        >Add Flow</v-btn
      >
    </v-toolbar>
    <v-data-table
      :search="search"
      :items="flows"
      :headers="processHeaders"
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
          <v-icon class="mr-2" @click="simulateWorkflow(props.item)"
            >play_circle</v-icon
          >
          <v-icon class="mr-2" @click="routeToProcess(props.item.id)"
            >edit</v-icon
          >
          <v-icon @click="deleteItem(props.item.id)">delete</v-icon>
        </td>
        <td class="text-xs-center" @click="routeToProcess(props.item.id)">
          {{ props.item.name }}
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="addItemModal" width="500px">
      <v-card flat color="white" v-if="addItemModal">
        <v-toolbar flat color="primary">
          <h3 class="white--text">New Process</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="addItemModal = false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-text-field label="Process Name" v-model="item.name"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center><v-btn v-if="item&&item.name" round color="primary" class="white--text" @click="saveNewItem()">Save</v-btn>
          <v-btn v-else round disabled>Save</v-btn></v-layout>
        </v-card-actions>
        <!-- <process></process> -->
      </v-card>
    </v-dialog>
    <v-dialog v-model="editItemModal" width="100%" height="100vh">
      <v-card flat color="white" v-if="item">
        <v-toolbar flat color="primary">
          <h3 class="white--text">Edit Process</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="editItemModal = false">X</v-btn>
        </v-toolbar>
        <editprocess :obj="item"></editprocess>
      </v-card>
    </v-dialog>
    <v-dialog v-model="simulationModal" width="750px">
      <v-card flat color="white" v-if="simulationData">
        <v-toolbar flat color="primary">
          <h3 class="white--text">Simulation: {{ simulationData.name }}</h3>
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            flat
            @click="(simulationModal = false), (simulationData = null)"
            >X</v-btn
          >
        </v-toolbar>
        <v-card-text v-if="currentItem">
          <v-layout justify-center align-center wrap>
            <v-flex xs12>
              <!-- <v-chip>{{ currentItem.id }}</v-chip> -->
              <h3 class="grey--text" style="text-transform: capitalize">
                {{ currentItem.html.split("_")[0] }}:
                {{ currentItem.data.name }}
              </h3>
              <h4
                class="grey--text font-weight-light"
                v-if="currentItem.function && data.length > 0"
                style="text-transform: capitalize"
              >
                {{ currentItem.function }} record:
              </h4>
            </v-flex>
            <v-flex
              xs6
              v-if="currentItem.function && currentItem.workflowData"
              class="text-xs-left"
            >
              <vue-json-pretty :path="'res'" :data="currentItem.workflowData">
              </vue-json-pretty>
            </v-flex>
            <v-flex xs12 v-if="currentItem.html.split('_')[0] == 'form'">
              <div
                v-for="element in currentItem.data.data"
                :key="element.id"
                style="margin-top: 10px"
              >
                <v-layout
                  justify-center
                  v-if="
                    element.inputType == 'Text Field' &&
                    element.type == 'String'
                  "
                >
                  <v-flex xs6 mx-3>
                    <v-text-field
                      v-if="element.required && element.maxLength"
                      v-model="currentItem.workflowData[element.field]"
                      :maxlength="element.maxLength"
                      :label="'*' + element.field"
                    ></v-text-field>
                    <v-text-field
                      v-else-if="!element.required && element.maxLength"
                      :maxlength="element.maxLength"
                      v-model="currentItem.workflowData[element.field]"
                      :label="element.field"
                    ></v-text-field>
                    <v-text-field
                      v-else-if="element.required && !element.maxLength"
                      v-model="currentItem.workflowData[element.field]"
                      :label="'*' + element.field"
                    ></v-text-field>
                    <v-text-field
                      v-else-if="!element.required && !element.maxLength"
                      v-model="currentItem.workflowData[element.field]"
                      :label="element.field"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout
                  justify-center
                  v-if="
                    element.inputType == 'Text Area' && element.type == 'String'
                  "
                >
                  <v-flex xs6 mx-3>
                    <v-textarea
                      v-if="element.required && element.maxLength"
                      v-model="currentItem.workflowData[element.field]"
                      :maxlength="element.maxLength"
                      :label="'*' + element.field"
                    ></v-textarea>
                    <v-textarea
                      v-else-if="!element.required && element.maxLength"
                      v-model="currentItem.workflowData[element.field]"
                      :maxlength="element.maxLength"
                      :label="element.field"
                    ></v-textarea>
                    <v-textarea
                      v-else-if="element.required && !element.maxLength"
                      v-model="currentItem.workflowData[element.field]"
                      :label="'*' + element.field"
                    ></v-textarea>
                    <v-textarea
                      v-else-if="!element.required && !element.maxLength"
                      v-model="currentItem.workflowData[element.field]"
                      :label="element.field"
                    ></v-textarea>
                  </v-flex>
                </v-layout>

                <v-layout
                  justify-center
                  v-else-if="
                    element.inputType == 'Text Field' &&
                    (element.type == 'Integer' || element.type == 'Decimal')
                  "
                >
                  <v-flex xs6 mx-3>
                    <v-text-field
                      v-if="element.required && (element.min || element.max)"
                      :min="element.min"
                      :max="element.max"
                      v-model="currentItem.workflowData[element.field]"
                      :label="'*' + element.field"
                      type="number"
                    ></v-text-field>
                    <v-text-field
                      v-else-if="
                        !element.required && (element.min || element.max)
                      "
                      :min="element.min"
                      :max="element.max"
                      v-model="currentItem.workflowData[element.field]"
                      :label="element.field"
                      type="number"
                    ></v-text-field>
                    <v-text-field
                      v-if="element.required && !element.min && !element.max"
                      :label="'*' + element.field"
                      v-model="currentItem.workflowData[element.field]"
                      type="number"
                    ></v-text-field>
                    <v-text-field
                      v-else-if="
                        !element.required && !element.min && !element.max
                      "
                      :label="element.field"
                      v-model="currentItem.workflowData[element.field]"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-center v-if="element.inputType == 'Select'">
                  <v-flex xs6 mx-3>
                    <v-select
                      v-if="element.required"
                      :label="'*' + element.field"
                      v-model="currentItem.workflowData[element.field]"
                      :items="element.options"
                    ></v-select>
                    <v-select
                      v-else
                      :label="element.field"
                      v-model="currentItem.workflowData[element.field]"
                      :items="element.options"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout justify-center v-if="element.inputType == 'Boolean'">
                  <v-flex xs6 mx-3>
                    <v-checkbox
                      v-if="element.required"
                      v-model="currentItem.workflowData[element.field]"
                      :label="'*' + element.field"
                    ></v-checkbox>
                    <v-checkbox v-else :label="element.field"></v-checkbox>
                  </v-flex>
                </v-layout>

                <v-layout justify-center v-if="element.inputType == 'Image'">
                  <v-flex xs6 mx-3>
                    <v-img
                      :key="key"
                      contain
                      max-height="150px"
                      :src="element.image"
                    ></v-img>
                    <div>
                      <v-btn
                        color="primary"
                        round
                        depressed
                        @click="clickImage(element.id)"
                        >Upload Image
                      </v-btn>
                      <input
                        ref="image"
                        class="d-none"
                        type="file"
                        accept="image/*"
                        @input="selectFile($event, element.id)"
                      />
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-layout justify-center align-center>
              <v-btn
                v-for="option in conditions"
                :key="option"
                round
                class="white--text"
                color="primary"
                @click="nextWorkflowItem(option)"
                >{{ option }}</v-btn
              >
            </v-layout>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      addItemModal: false,
      conditions: [],
      editItemModal: false,
      item: {},
      flows: [],
      processHeaders: [
        {
          text: "Actions",
          align: "center",
          sortable: false,
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
      ],
      search: "",
      simulationModal: false,
      simulationData: null,
      data: [],
      currentItem: {},
      previousItem: {},
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.fetchFlows();
    },
    fetchFlows() {
      Api()
        .get("/workflows/flow")
        .then((res) => {
          this.flows = res.data;
          for (let i = 0; i < this.flows.length; i++) {
            this.flows[i].data = JSON.parse(this.flows[i].data);
          }
        });
    },
    async confirmStatus(item) {
      let result = null;
      if (item.html.split("_")[0] == "form") {
        let requiredFields = item.data.data.filter((x) => x.required);
        requiredFields = requiredFields.map((x) => x.field);
        let objectFields = Object.keys(item.workflowData);
        result = "Form Completed";
        for (let i = 0; i < requiredFields.length; i++) {
          if (!objectFields.includes(requiredFields[i])) {
            result = "Form Incomplete";
          }
        }
      } else if (item.html.split("_")[0] == "Start") {
        result = "Success";
      } else if (item.html.split("_")[0] == "Start") {
        result = "Success";
      }
      return result;
    },
    async nextWorkflowItem(condition) {
      this.currentItem.status = condition;
      this.previousItem = this.currentItem;
      let keys = Object.keys(this.currentItem.outputs);
      let output = [];
      for (let i = 0; i < keys.length; i++) {
        if (
          this.currentItem.outputs[keys[i]].condition == this.currentItem.status
        ) {
          output.push(this.currentItem.outputs[keys[i]]);
          i = keys.length;
        }
      }
      this.data.push(this.currentItem);
      if (output.length == 1) {
        this.currentItem = this.simulationData.data.drawflow.Home.data[
          output[0].connections[0].node
        ];
      }
      this.conditions = [];
      let conditionOptions = Object.keys(this.currentItem.outputs);
      for (let i = 0; i < conditionOptions.length; i++) {
        this.conditions.push(
          this.currentItem.outputs[conditionOptions[i]].condition
        );
      }
      this.currentItem.workflowData = {};
      if (this.currentItem.data.type.split("_")[0] == "model") {
        let fields = Object.keys(this.previousItem.workflowData);
        let mappedFields = Object.values(this.currentItem.mappedData);
        let mappedKeys = Object.keys(this.currentItem.mappedData);

        for (let i = 0; i < fields.length; i++) {
          let index = mappedFields.indexOf(fields[i]);
          if (index != -1) {
            this.currentItem.workflowData[
              mappedKeys[index]
            ] = this.previousItem.workflowData[fields[i]];
          }
        }
      }
    },
    simulateWorkflow(item) {
      this.simulationData = item;
      console.log(this.simulationData);
      let keys = Object.keys(item.data.drawflow.Home.data);
      for (let i = 0; i < keys.length; i++) {
        if (
          item.data.drawflow.Home.data[keys[i]].name.split("_")[0] == "Start"
        ) {
          this.currentItem = item.data.drawflow.Home.data[keys[i]];
        }
      }

      this.conditions = [];
      let conditionOptions = Object.keys(this.currentItem.outputs);
      for (let i = 0; i < conditionOptions.length; i++) {
        this.conditions.push(
          this.currentItem.outputs[conditionOptions[i]].condition
        );
      }
      console.log(this.conditions);

      console.log(this.currentItem);
      this.currentItem.workflowData = {};
      console.log(this.currentItem);
      this.simulationModal = true;
    },
    routeToProcess(id) {
      this.$router.push({ path: "/workflows/flow/" + id });
    },
    addItem() {
      if (this.authAdmin(this.$store.state.currentRoute)) {
        this.addItemModal = true;
        this.item = {}
      }
    },
    saveNewItem(){
      Api().post('/workflows/flow', this.item).then(res=>{
        this.routeToProcess(res.data.id)
      })
    },
    editItem(item) {
      this.item = item;
      this.editItemModal = false;
    },
    deleteItem(id) {
      confirm("Are you sure you want to delete this process?") &&
        Api()
          .put("/workflows/flow/" + id, {
            isActive: false,
            isDeleted: true,
          })
          .then((res) => {
            this.fetchFlows();
          });
    },
  },
};
</script>